import React from 'react';
import { createFeature } from '@edreamsodigeo/frontend-core';

import { EQUAL_PROMINENCE_IT_4_MOBILE } from 'clientState/ab/aliases';
import { useEqualProminencePrimeDisplayMobile } from 'clientState/hooks/useEqualProminencePrimeDisplayMobile';

import { LayoutProps } from '../types';
import LegacyLayout from './versions/legacy/ThreeColumnsItineraryLayout';
import EqualProminenceLayout from './versions/equalProminence/ThreeColumnsItineraryLayout';

const EqualProminenceLayoutSelector = (props: LayoutProps) => {
  const isEqualProminencePrimeDisplayMobile =
    useEqualProminencePrimeDisplayMobile();

  return isEqualProminencePrimeDisplayMobile ? (
    <EqualProminenceLayout {...props} />
  ) : (
    <LegacyLayout {...props} />
  );
};

const ThreeColumnsItineraryLayout = createFeature({
  name: EQUAL_PROMINENCE_IT_4_MOBILE,
  variations: [LegacyLayout, EqualProminenceLayoutSelector],
  version: 1,
});

export default ThreeColumnsItineraryLayout;
